import { defineComponent } from "vue";
import { Promotion } from "@lemmonhq/types";
import { RightSheet, useLocalization } from "@lemmonhq/uikit";
import { formatPromotionDescription } from "@lemmonhq/orders";

export type PromotionInfoModalProps = {
  promotions: Promotion[];
  isOpen: boolean;
  onClose: () => void;
};

export const PromotionInfoModal = defineComponent<PromotionInfoModalProps>({
  name: "PromotionInfoModal",
  props: ["promotions", "isOpen", "onClose"],
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <RightSheet
        title={t("customer.shop_shell.available_offers")}
        isOpen={props.isOpen}
        onClose={() => props.onClose()}
        class="bg-base-200 h-full"
      >
        <div class="p-4">
          {props.promotions.map((promotion) => (
            <div key={promotion.id} class="mb-6 bg-base-100 rounded-lg p-4">
              <h3 class="text-lg font-semibold text-accent mb-2">
                {promotion.name}
              </h3>
              <div class="text-sm text-base-content opacity-80">
                {formatPromotionDescription(promotion)}
              </div>

              {/* Show active days/times if available */}
              {Object.keys(promotion.days).length > 0 && (
                <div class="mt-3 pt-3 border-t border-base-300">
                  <h4 class="text-sm font-medium text-accent mb-2">
                    {t("customer.shop_shell.available")}:
                  </h4>
                  <div class="text-xs text-base-content opacity-70">
                    {Object.entries(promotion.days)
                      .filter(([_, timeRanges]) => timeRanges.length > 0)
                      .map(([day, timeRanges]) => (
                        <div key={day} class="capitalize">
                          {day}:{" "}
                          {timeRanges
                            .map(
                              (range) =>
                                `${range.start_time}-${range.end_time}`,
                            )
                            .join(", ")}
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </RightSheet>
    );
  },
});
